import { render, staticRenderFns } from "./QueuedOrderTable.vue?vue&type=template&id=0daa7312"
import script from "./QueuedOrderTable.vue?vue&type=script&lang=js"
export * from "./QueuedOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports